import React from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";

const { Dragger } = Upload;

const DraggerUpload = ({ loading, accept, fileDescription, ...props }) => (
  <Dragger disabled={loading} accept={accept} {...props}>
    <p className="ant-upload-drag-icon">
      <InboxOutlined />
    </p>
    <p className="ant-upload-text">Click or drag file to this area to upload</p>
    <p className="ant-upload-hint">
      {fileDescription ?? accept.toUpperCase().replace(",", ", ") + " File"}
    </p>
  </Dragger>
);

export default DraggerUpload;
